"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { type JSX, useMemo } from "react";
import type { ApiWaveOutcome } from "@/generated/models/ApiWaveOutcome";
import type { WaveOutcomeDistributionState } from "@/types/waves.types";
import { useWaveOutcomeDistributionQuery } from "@/hooks/waves/useWaveOutcomeDistributionQuery";
import { WaveRepOutcome } from "./WaveRepOutcome";
import { WaveNICOutcome } from "./WaveNICOutcome";
import { WaveManualOutcome } from "./WaveManualOutcome";
import { ApiWaveOutcomeCredit } from "@/generated/models/ApiWaveOutcomeCredit";
enum OutcomeType {
  MANUAL = "MANUAL",
  NIC = "NIC",
  REP = "REP",
}
interface WaveOutcomeProps {
  readonly waveId: string;
  readonly outcome: ApiWaveOutcome;
}
export const WaveOutcome: FC<WaveOutcomeProps> = t0 => {
  const $ = _c(27);
  const {
    waveId,
    outcome
  } = t0;
  let t1;
  if ($[0] !== outcome.index || $[1] !== waveId) {
    t1 = {
      waveId,
      outcomeIndex: outcome.index
    };
    $[0] = outcome.index;
    $[1] = waveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    items,
    totalCount,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
    isError,
    errorMessage
  } = useWaveOutcomeDistributionQuery(t1);
  const t2 = Boolean(hasNextPage);
  let t3;
  if ($[3] !== errorMessage || $[4] !== fetchNextPage || $[5] !== isError || $[6] !== isFetchingNextPage || $[7] !== isLoading || $[8] !== items || $[9] !== t2 || $[10] !== totalCount) {
    t3 = {
      items,
      totalCount,
      hasNextPage: t2,
      isFetchingNextPage,
      fetchNextPage,
      isLoading,
      isError,
      errorMessage
    };
    $[3] = errorMessage;
    $[4] = fetchNextPage;
    $[5] = isError;
    $[6] = isFetchingNextPage;
    $[7] = isLoading;
    $[8] = items;
    $[9] = t2;
    $[10] = totalCount;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const distributionState = t3;
  const getOutcomeType = () => {
    if (outcome.credit === ApiWaveOutcomeCredit.Rep) {
      return OutcomeType.REP;
    }
    if (outcome.credit === ApiWaveOutcomeCredit.Cic) {
      return OutcomeType.NIC;
    }
    return OutcomeType.MANUAL;
  };
  const outcomeType = getOutcomeType();
  let t4;
  if ($[12] !== distributionState || $[13] !== outcome) {
    t4 = <WaveRepOutcome outcome={outcome} distribution={distributionState} />;
    $[12] = distributionState;
    $[13] = outcome;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== distributionState || $[16] !== outcome) {
    t5 = <WaveNICOutcome outcome={outcome} distribution={distributionState} />;
    $[15] = distributionState;
    $[16] = outcome;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== distributionState || $[19] !== outcome) {
    t6 = <WaveManualOutcome outcome={outcome} distribution={distributionState} />;
    $[18] = distributionState;
    $[19] = outcome;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t7 = {
      [OutcomeType.REP]: t4,
      [OutcomeType.NIC]: t5,
      [OutcomeType.MANUAL]: t6
    };
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const component = t7;
  const t8 = component[outcomeType];
  let t9;
  if ($[25] !== t8) {
    t9 = <div>{t8}</div>;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};